import React, { Dispatch } from "react";
import InformativeModal from "./InformativeModal";
import ClipboardErrorIcon from "../images/ClipboardErrorIcon";
import { Grid } from "@material-ui/core";

interface Props {
  open: boolean;
  setOpen: Dispatch<React.SetStateAction<boolean>>;
  deleteCase: () => void;
  numCases: number;
  loading?: boolean;
}

export default function MultiDeleteModal({ open, setOpen, deleteCase, numCases, loading }: Props) {
  return (
    <InformativeModal
      headerText={
        <Grid container direction="column" justifyContent="space-between" alignItems="center">
          <span>
            Are you sure you want to delete {numCases} case{numCases === 1 ? "" : "s"}?
          </span>
        </Grid>
      }
      subHeaderText="This action cannot be undone."
      icon={<ClipboardErrorIcon />}
      primaryButtonText="Delete case"
      primaryButtonAction={deleteCase}
      primaryButtonLoading={loading}
      primaryButtonDisabled={loading}
      tertiaryButtonText="Cancel"
      tertiaryButtonAction={() => setOpen(false)}
      showDivider
      open={open}
      onClose={() => setOpen(false)}
    />
  );
}
